import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

const path = "/management/roadmap-stage";
export const managementGdprRoadmap = createCrudVuexModule({
  namespaced: true,
  path,
  state: {
    editedTask: undefined,
    tasks: [],
    editedStages: [],
    //
    descriptionProductTutorial: undefined,
    descriptionDepartmentQuestions: undefined,
    descriptionInventoryUpdate: undefined,
    descriptionGdprPolicy: undefined,
    descriptionGdprRisk: undefined,
    descriptionReportPrepare: undefined,
    //
    isProductTutorialLoading: false,
    isDepartmentQuestionsLoading: false,
    isInventoryUpdateLoading: false,
    isGdprPolicyLoading: false,
    isGdprRiskLoading: false,
    isReportPrepareLoading: false,
  },
  getters: {
    editedTask: (state) => state.editedTask,
    tasks: (state) => state.tasks,
    editedStages: (state) => state.editedStages,
    //
    descriptionProductTutorial: (state) => state.descriptionProductTutorial,
    descriptionDepartmentQuestions: (state) => state.descriptionDepartmentQuestions,
    descriptionInventoryUpdate: (state) => state.descriptionInventoryUpdate,
    descriptionGdprPolicy: (state) => state.descriptionGdprPolicy,
    descriptionGdprRisk: (state) => state.descriptionGdprRisk,
    descriptionReportPrepare: (state) => state.descriptionReportPrepare,
    //
    isProductTutorialLoading: (state) => state.isProductTutorialLoading,
    isDepartmentQuestionsLoading: (state) => state.isDepartmentQuestionsLoading,
    isInventoryUpdateLoading: (state) => state.isInventoryUpdateLoading,
    isGdprPolicyLoading: (state) => state.isGdprPolicyLoading,
    isGdprRiskLoading: (state) => state.isGdprRiskLoading,
    isReportPrepareLoading: (state) => state.isReportPrepareLoading,
  },
  mutations: {
    reset: (state, value) => {
      state.editedTask = undefined;
      state.tasks = [];
      state.editedStages = [];

      state.descriptionProductTutorial = undefined;
      state.descriptionDepartmentQuestions = undefined;
      state.descriptionInventoryUpdate = undefined;
      state.descriptionGdprPolicy = undefined;
      state.descriptionGdprRisk = undefined;
      state.descriptionReportPrepare = undefined;

      state.isProductTutorialLoading = false;
      state.isDepartmentQuestionsLoading = false;
      state.isInventoryUpdateLoading = false;
      state.isGdprPolicyLoading = false;
      state.isGdprRiskLoading = false;
      state.isReportPrepareLoading = false;

      state.isUpdating = false;
      state.isLoading = false;
    },

    clearEditedStages: (state, value) => (state.editedStages = []),

    isProductTutorialLoading: (state, value) => (state.isProductTutorialLoading = value),
    isDepartmentQuestionsLoading: (state, value) => (state.isDepartmentQuestionsLoading = value),
    isInventoryUpdateLoading: (state, value) => (state.isInventoryUpdateLoading = value),
    isGdprPolicyLoading: (state, value) => (state.isGdprPolicyLoading = value),
    isGdprRiskLoading: (state, value) => (state.isGdprRiskLoading = value),
    isReportPrepareLoading: (state, value) => (state.isReportPrepareLoading = value),

    descriptionProductTutorial: (state, value) => {
      state.descriptionProductTutorial = value;
      if (!state.editedStages.includes("GDPR_PRODUCT_TUTORIAL")) {
        state.editedStages.push("GDPR_PRODUCT_TUTORIAL");
      }
    },
    descriptionDepartmentQuestions: (state, value) => {
      state.descriptionDepartmentQuestions = value;
      if (!state.editedStages.includes("GDPR_DEPARTMENT_QUESTIONS")) {
        state.editedStages.push("GDPR_DEPARTMENT_QUESTIONS");
      }
    },
    descriptionInventoryUpdate: (state, value) => {
      state.descriptionInventoryUpdate = value;
      if (!state.editedStages.includes("GDPR_INVENTORY_UPDATE")) {
        state.editedStages.push("GDPR_INVENTORY_UPDATE");
      }
    },
    descriptionGdprPolicy: (state, value) => {
      state.descriptionGdprPolicy = value;
      if (!state.editedStages.includes("GDPR_POLICY")) {
        state.editedStages.push("GDPR_POLICY");
      }
    },
    descriptionGdprRisk: (state, value) => {
      state.descriptionGdprRisk = value;
      if (!state.editedStages.includes("GDPR_RISK")) {
        state.editedStages.push("GDPR_RISK");
      }
    },
    descriptionReportPrepare: (state, value) => {
      state.descriptionReportPrepare = value;

      if (!state.editedStages.includes("GDPR_REPORT_PREPARE")) {
        state.editedStages.push("GDPR_REPORT_PREPARE");
      }
    },

    editedTask: (state, value) => (state.editedTask = value),

    addTaskItemsToStage: (state, { task }) => {
      if (!state.editedStages.includes(task.stage)) {
        state.editedStages.push(task.stage);
      }

      if (!task._id) {
        task._id = "id" + new Date().getTime(); //id atama
      }

      state.tasks = [...state.tasks, { ...task }];
    },
    updateTaskItemsToStage: (state, { task }) => {
      if (!state.editedStages.includes(task.stage)) {
        state.editedStages.push(task.stage);
      }

      state.tasks = state.tasks.map((t) => {
        if (t._id == task._id) {
          t = task;
        }

        t.blockedByTasks = t.blockedByTasks?.map((x) => {
          if (x._id == task._id) {
            return task;
          }
          return x;
        });

        return t;
      });
    },

    removeTaskItem: (state, { task }) => {
      if (!state.editedStages.includes(task.stage)) {
        state.editedStages.push(task.stage);
      }

      state.tasks = state.tasks.filter((t) => t._id != task._id);
    },
  },
  actions: {
    async save({ getters, commit, dispatch }) {
      try {
        commit("isUpdating", true);

        const response = await Promise.all(
          getters.editedStages.map(async (stage) => {
            let payload = {
              tasks: getters.tasks.filter((t) => t.stage == stage),
              roadmapDefinition: "GDPR_PRODUCT_ROADMAP",
              definition: stage,
              description: null,
              next: null,
            };

            if (stage == "GDPR_PRODUCT_TUTORIAL") {
              payload.description = getters.descriptionProductTutorial;
              payload.first = true;
              payload.next = ["GDPR_DEPARTMENT_QUESTIONS"];
            } else if (stage == "GDPR_DEPARTMENT_QUESTIONS") {
              payload.description = getters.descriptionDepartmentQuestions;
              payload.next = ["GDPR_INVENTORY_UPDATE"];
            } else if (stage == "GDPR_INVENTORY_UPDATE") {
              payload.description = getters.descriptionInventoryUpdate;
              payload.next = ["GDPR_POLICY"];
            } else if (stage == "GDPR_POLICY") {
              payload.description = getters.descriptionGdprPolicy;
              payload.next = ["GDPR_RISK"];
            } else if (stage == "GDPR_RISK") {
              payload.description = getters.descriptionGdprRisk;
              payload.next = ["GDPR_REPORT_PREPARE"];
            } else if (stage == "GDPR_REPORT_PREPARE") {
              payload.description = getters.descriptionReportPrepare;
            }

            try {
              commit("isUpdating", true);
              payload = await dispatch("preparePayload", {
                editedEntity: {},
                form: payload,
              });

              const response = await rest.put(`${path}`, { item: payload });
              return response;
            } catch (e) {
              console.error(e);
            }
          })
        );

        return response;
      } finally {
        commit("reset");
      }
    },

    async loadStages({ getters, rootGetters, commit, dispatch }) {
      try {
        commit("reset");

        const language = rootGetters["user/account"].language ?? "tr";
        const stages = ["GDPR_PRODUCT_TUTORIAL", "GDPR_DEPARTMENT_QUESTIONS", "GDPR_INVENTORY_UPDATE", "GDPR_POLICY", "GDPR_RISK", "GDPR_REPORT_PREPARE"];
        const response = await Promise.all(
          stages.map(async (stage) => {
            try {
              if (stage == "GDPR_PRODUCT_TUTORIAL") {
                commit("isProductTutorialLoading", true);
              } else if (stage == "GDPR_DEPARTMENT_QUESTIONS") {
                commit("isDepartmentQuestionsLoading", true);
              } else if (stage == "GDPR_INVENTORY_UPDATE") {
                commit("isInventoryUpdateLoading", true);
              } else if (stage == "GDPR_POLICY") {
                commit("isGdprPolicyLoading", true);
              } else if (stage == "GDPR_RISK") {
                commit("isGdprRiskLoading", true);
              } else if (stage == "GDPR_REPORT_PREPARE") {
                commit("isReportPrepareLoading", true);
              }

              const response = await rest.post(`${path}`, { roadmapDefinition: "GDPR_PRODUCT_ROADMAP", definition: stage });
              if (response?.data && typeof response.data === "object") {
                if (response.data.description) {
                  const description = response.data.description[language];

                  if (stage == "GDPR_PRODUCT_TUTORIAL") {
                    commit("descriptionProductTutorial", description);
                  } else if (stage == "GDPR_DEPARTMENT_QUESTIONS") {
                    commit("descriptionDepartmentQuestions", description);
                  } else if (stage == "GDPR_INVENTORY_UPDATE") {
                    commit("descriptionInventoryUpdate", description);
                  } else if (stage == "GDPR_POLICY") {
                    commit("descriptionGdprPolicy", description);
                  } else if (stage == "GDPR_RISK") {
                    commit("descriptionGdprRisk", description);
                  } else if (stage == "GDPR_REPORT_PREPARE") {
                    commit("descriptionReportPrepare", description);
                  }
                }

                response.data.tasks.forEach((task) => {
                  task.stage = stage;
                  task.description = task.description;
                  commit("addTaskItemsToStage", { task });
                });
              }
              return response?.data;
            } catch (e) {
              console.error(e);
            } finally {
              if (stage == "GDPR_PRODUCT_TUTORIAL") {
                commit("isProductTutorialLoading", false);
              } else if (stage == "GDPR_DEPARTMENT_QUESTIONS") {
                commit("isDepartmentQuestionsLoading", false);
              } else if (stage == "GDPR_INVENTORY_UPDATE") {
                commit("isInventoryUpdateLoading", false);
              } else if (stage == "GDPR_POLICY") {
                commit("isGdprPolicyLoading", false);
              } else if (stage == "GDPR_RISK") {
                commit("isGdprRiskLoading", false);
              } else if (stage == "GDPR_REPORT_PREPARE") {
                commit("isReportPrepareLoading", false);
              }
            }
          })
        );

        return response;
      } catch (e) {
        console.error(e);
      } finally {
        commit("clearEditedStages");
      }
    },
  },
});
